<script>
  import TimeTrackerDetails from "./TimeTracker/TimeTrackerDetails.svelte";
  import TimeTrackerOverview from "./TimeTracker/TimeTrackerOverview.svelte";

  let showTimeTrackerOverview = true;
  $$restProps;
</script>

{#if showTimeTrackerOverview === true}
  <TimeTrackerOverview />
{:else}
  <TimeTrackerDetails />
{/if}
